export const GLOBAL_CONFIG = {
  profile: {
    archive: false,
  },
};
